import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';

import { AutoNumericDirective } from '../../../directives/auto-numeric.directive';
import { BaseUI } from '../../base.ui';
import { OrderAction, ProductInterface, SelectedProductInterface } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';
import { Id } from 'src/app/main/domain/data';

@Component({
    selector: 'thr-operate-subscription',
    templateUrl: './operate-subscription.component.html',
    styleUrls: ['./operate-subscription.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OperateSubscriptionComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public initialAmount;

    @Input()
    editable = true;

    @Input()
    product: ProductInterface;

    @Input()
    selectedProduct: SelectedProductInterface;

    @Input()
    canExonerate = false;

    @Output()
    detail: EventEmitter<Id> = new EventEmitter();

    @Output()
    exonerate: EventEmitter<Id> = new EventEmitter();

    @ViewChild('autoNumericDirective')
    autoNumericDirective: AutoNumericDirective;

    constructor(parentEvents: ParentEvents, private cdr: ChangeDetectorRef) {
        super(parentEvents);
    }

    ngOnInit(): void {
        this.initialAmount = this.selectedProduct.order.amount || 0;
        this.cdr.detectChanges();

        if (this.editable) {
            this.selectedProduct.order.action = OrderAction.AMOUNT;
            this.selectedProduct.order.withShares = false;
            this.cdr.detectChanges();
        }
    }

    get minimumInvestment(): number {
        if (this.product) {
            if (this.selectedProduct.amount > 0) {
                return this.product.minimumContribution ? this.product.minimumContribution : 0.01;
            } else {
                return this.product.minimumInvestment ? this.product.minimumInvestment : 0.01;
            }
        }

        return 0;
    }

    get minimumInvestmentMsg(): string {
        if (this.product) {
            if (this.selectedProduct.amount > 0) {
                return 'form.validation.minimum-contribution';
            } else {
                return 'form.validation.minimum-amount';
            }
        }

        return null;
    }

    get maximumInvestment(): number {
        return 999999;
    }

    onAmountChange() {
        setTimeout(() => {
            if (this.autoNumericDirective) {
                this.selectedProduct.order.amount = this.autoNumericDirective.value;
            }

            if (this.product) {
                this.selectedProduct.order.shares = Number((this.selectedProduct.order.amount / this.product.lastPrice).toFixed(8));
            }

            this.cdr.detectChanges();
        });
    }

    onExonerate() {
        this.exonerate.emit(this.product.id as Id);
    }
}
